export const strings = {
  english: {
    product: 'Product',
    remaining: 'Downloads remaining',
    expires: 'Expires',
    download: 'Download',
  },

  japan: {
    product: '注文商品',
    remaining: '残りのダウンロード',
    expires: '期限',
    download: 'ダウンロード',
  },
};
